import { getPasswordRules, getSecretQuestions } from '@/service/auth'
import { getUser, saveUserData, toggleSignLanguage } from '@/service/user'
import {
  getGroupsAccess,
  getGroupsAccessTickets,
  getGroupsTree,
} from '@/service/groups'

// initial state
function initialState() {
  return {
    user: getUser(),
    currentGroup: undefined,
    groupList: [],
    groupListTickets: [],
    groupsTree: [],
    selectedGroup: undefined,
    signLanguageLoading: false,
    showFilter: false,
  }
}

const state = initialState()

// getters
const getters = {
  user: state => state.user,
  currentGroup: state => state.currentGroup,
  groupList: state => state.groupList,
  groupListTickets: state => state.groupListTickets,
  groupsTree: state => state.groupsTree,
  selectedGroup: state => state.selectedGroup,
  signLanguageLoading: state => state.signLanguageLoading,
  showFilter: state => state.showFilter,
}

const actions = {
  loadSecretQuestions() {
    return getSecretQuestions()
  },

  loadPasswordRules(_, { token, action }) {
    return getPasswordRules({ token, action })
  },

  async toggleSignLanguage({ commit }, body) {
    commit('updateSignLanguageLoading', true)
    await toggleSignLanguage(body)
  },

  loadUserInfo({ commit }) {
    commit('LOAD_USER_INFO')
  },

  saveUserData({ commit }, jwt) {
    saveUserData(jwt)
    commit('LOAD_USER_INFO')
  },

  loadGroupList({ commit }) {
    getGroupsAccess().then(({ data }) => commit('setGroupList', data))
  },

  setGroupListTickets({ commit }) {
    getGroupsAccessTickets().then(({ data }) =>
      commit('setGroupListTickets', data)
    )
  },

  loadGroupsTree({ commit }) {
    return getGroupsTree().then(({ data }) => commit('setGroupsTree', data))
  },

  updateSelectedGroup({ commit }, value) {
    commit('setSelectedGroup', value)
  },

  updateShowFilter({ commit }, value) {
    commit('setShowFilter', value)
  },
}

// mutations
const mutations = {
  updateSignLanguageLoading(state, signLanguageLoading) {
    state.signLanguageLoading = signLanguageLoading
  },

  LOAD_USER_INFO(state) {
    Object.assign(state.user, getUser())
  },

  updateCurrentGroup(state, name) {
    state.currentGroup = name
  },

  setGroupList(state, list) {
    state.groupList = list
  },

  setGroupListTickets(state, list) {
    state.groupListTickets = list
  },

  setGroupsTree(state, tree) {
    state.groupsTree = tree
  },

  setSelectedGroup(state, value) {
    state.selectedGroup = value
  },

  setShowFilter(state, value) {
    state.showFilter = value
  },
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
